import { render, staticRenderFns } from "./BaseServices.vue?vue&type=template&id=dd27b000"
import script from "./BaseServices.vue?vue&type=script&lang=js"
export * from "./BaseServices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports